"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _styles = require("@material-ui/core/styles");
var _Box = _interopRequireDefault(require("@material-ui/core/Box"));
var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _openingdates = _interopRequireDefault(require("../openingdates"));
var _sociallinks = _interopRequireDefault(require("../sociallinks"));
var _uimodal = _interopRequireDefault(require("../uimodal"));
var _websiteprofile = _interopRequireDefault(require("../websiteprofile"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useStyles = (0, _styles.makeStyles)(theme => ({
  imageWrapper: {
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
    marginBottom: theme.spacing(2)
  },
  socialMedia: {
    display: "block"
  },
  socialMediaHeadline: {
    marginBottom: theme.spacing(1.5)
  }
}));
const AppInfo = _ref => {
  let {
    open,
    setOpen
  } = _ref;
  const {
    REACT_APP_LOGOAPPINFO,
    PUBLIC_URL,
    REACT_APP_LOGOMAXWIDTH
  } = process.env;
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const css = useStyles();
  return /*#__PURE__*/_react.default.createElement(_uimodal.default, {
    open: open,
    setOpen: setOpen
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 12,
    className: css.imageWrapper
  }, /*#__PURE__*/_react.default.createElement("img", {
    style: {
      display: "block",
      maxWidth: REACT_APP_LOGOMAXWIDTH,
      width: "100%"
    },
    src: PUBLIC_URL + "/img/" + REACT_APP_LOGOAPPINFO,
    alt: ""
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 12,
    sm: 7
  }, /*#__PURE__*/_react.default.createElement(_websiteprofile.default, {
    noLogo: true
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 12,
    sm: 5
  }, /*#__PURE__*/_react.default.createElement(_Box.default, {
    mb: 2
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: css.socialMediaHeadline,
    variant: "subtitle1"
  }, t("site.ui.labels.socialMedia")), /*#__PURE__*/_react.default.createElement(_sociallinks.default, {
    classes: css.socialMedia
  })), /*#__PURE__*/_react.default.createElement(_Box.default, {
    mb: 2
  }, /*#__PURE__*/_react.default.createElement(_openingdates.default, null)))));
};
var _default = exports.default = AppInfo;